import createForm from "@/utils/form"

export const kycForm = createForm<Kyc.Data.Insert>()
